export class HttpProblemType {
    public static readonly CONTENT_TYPE = 'application/problem+json';

    public static readonly NOT_FOUND = 'http://www.statusmatcher.com/http_problem_type/not_found';
    public static readonly CONSTRAINT_VIOLATION = 'http://www.statusmatcher.com/http_problem_type/constraint_violation';
    public static readonly UNSUPPORTED_OPERATION = 'http://www.statusmatcher.com/http_problem_type/unsupported_operation';
    public static readonly INTERNAL_SERVER_ERROR = 'http://www.statusmatcher.com/http_problem_type/internal_server_error';
}